<ngx-loading
  [show]="loading"
  [config]="{ backdropBorderRadius: '3px', primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }">
</ngx-loading>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: rgb(255, 250, 244)">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()" *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h3>CTVET Attendance & Course Tracker / Attendance</h3>
    </mat-toolbar>

    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="card">
                <div class="card-body">
                  <form (ngSubmit)="onSubmit()" #attendanceForm="ngForm">
                    
                    <!-- Name Field -->
                    <div class="form-group">
                      <label for="studentName">Name</label>
                      <select class="form-control" id="studentName" [(ngModel)]="selectedStudent" name="studentName" required>
                        <option [ngValue]="null" disabled>Select a student</option>
                        <option *ngFor="let student of students" [ngValue]="student">{{student.fullname}}</option>
                      </select>
                      <div *ngIf="submitted && !selectedStudent" class="text-danger">
                        Please select a student.
                      </div>
                    </div>

                    <!-- VMS ID Field (Readonly) -->
                    <div class="form-group">
                      <label for="vmsId">VMS ID</label>
                      <input type="text" class="form-control" id="vmsId" [value]="selectedStudent?.vmsId" readonly>
                    </div>

                    <!-- Date Field -->
                    <div class="form-group">
                      <label for="date">Date</label>
                      <input type="date" class="form-control" id="date" [(ngModel)]="date" name="date" required>
                      <div *ngIf="submitted && !selectedStudent" class="text-danger">
                        Please select a date.
                      </div>
                    </div>

                    <!-- Course Field -->
                    <div class="form-group">
                      <label for="courseName">Course</label>
                      <select class="form-control" id="courseName" [(ngModel)]="selectedCourse" name="courseName" required>
                        <option [ngValue]="null" disabled>Select a course</option>
                        <option *ngFor="let course of courses" [ngValue]="course">{{ course.name }}</option>
                      </select>
                      <div *ngIf="submitted && !selectedStudent" class="text-danger">
                        Please select a course.
                      </div>
                    </div>

                    <!-- Group Field (Readonly) -->
                    <div class="form-group">
                      <label for="group">Group</label>
                      <input type="text" class="form-control" id="group" [value]="selectedStudent?.groupName" readonly>
                    </div>

                    <!-- Status Field (Radio Buttons) -->
                    <div class="form-group">
                      <label>Status</label>
                      <div class="d-flex">
                        <div class="form-check me-3"> <!-- Add margin-end for spacing -->
                          <input class="form-check-input" type="radio" name="status" id="present" value="Present" [(ngModel)]="status" required>
                          <label class="form-check-label" for="present">Present</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="status" id="absent" value="Absent" [(ngModel)]="status" required>
                          <label class="form-check-label" for="absent">Absent</label>
                        </div>
                      </div>
                      <div *ngIf="submitted && !status" class="text-danger">
                        Please select attendance status.
                      </div>
                    </div>
                    

                    <!-- Image Capture Field -->
                    <div class="form-group">
                      <label>live camera-ready!</label>
                      <div class="image-capture-area">
                        <div *ngIf="!capturedImage" class="capture-placeholder">
                          <div class="responsive-camera">
                          <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)">
                          </webcam>
                        </div>
                          <button type="button" class="btn btn-secondary mt-2" (click)="captureImage()">Capture Image</button>
                        </div>
                        <div *ngIf="capturedImage" class="image-frame">
                          <img [src]="capturedImage" alt="Captured image" class="captured-image">
                        </div>
                      </div>
                      <div *ngIf="capturedImage" class="text-center mt-2">
                        <button type="button" class="btn btn-secondary btn-sm" (click)="retakeImage()">Retake</button>
                      </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="form-group-btn">
                      <button type="submit" class="btn btn-primary btn-block" [disabled]="!capturedImage || !isFormValid()">Submit</button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>        
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
